(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ink-nib-notify-me-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('notify-me-form')) {
    customElements.define(
      'notify-me-form',
      class NotifyMeForm extends HTMLElement {
        connectedCallback() {
          const successMessage = this.querySelector('.notify-me__success--complete');
          if (successMessage) {
            const successUrl = this.dataset.successUrl;
            if (successUrl) {
              window.location.replace(successUrl);
              return;
            }

            successMessage.focus();
            return;
          }

          this.typeRadios = Array.from(this.querySelectorAll('[data-notify-type]'));
          this.newPanel = this.querySelector('[data-notify-panel="new"]');
          this.stockPanel = this.querySelector('[data-notify-panel="stock"]');
          this.newSelect = this.querySelector('[data-new-option]');
          this.productSelect = this.querySelector('[data-stock-product]');
          this.variantSelect = this.querySelector('[data-stock-variant]');
          this.noStockMessage = this.querySelector('[data-no-stock]');

          this.typeRadios.forEach((radio) => {
            radio.addEventListener('change', () => this.updateType());
          });

          if (this.productSelect) {
            this.productSelect.addEventListener('change', () => this.updateVariants());
          }

          this.updateStockState();
          this.updateType();
        }

        updateType() {
          const selected = this.querySelector('[data-notify-type]:checked');
          const type = selected ? selected.dataset.notifyType : '';

          this.togglePanel(this.newPanel, type === 'new');
          this.togglePanel(this.stockPanel, type === 'stock');

          if (this.newSelect) {
            this.newSelect.disabled = type !== 'new';
            this.newSelect.required = type === 'new';
          }

          if (this.productSelect) {
            const stockActive = type === 'stock' && this.productSelect.options.length > 1;
            this.productSelect.disabled = !stockActive;
            this.productSelect.required = stockActive;
          }

          if (type === 'stock') {
            this.updateVariants();
          } else if (this.variantSelect) {
            this.variantSelect.disabled = true;
            this.variantSelect.required = false;
          }
        }

        togglePanel(panel, show) {
          if (!panel) return;
          panel.hidden = !show;
        }

        updateStockState() {
          if (!this.productSelect || !this.noStockMessage) return;
          const hasStockRequests = this.productSelect.options.length > 1;
          this.noStockMessage.hidden = hasStockRequests;
        }

        updateVariants() {
          if (!this.productSelect || !this.variantSelect) return;

          const selectedOption = this.productSelect.options[this.productSelect.selectedIndex];
          const productId = selectedOption ? selectedOption.dataset.productId : '';

          this.variantSelect.innerHTML = '';

          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = productId ? 'Choose a size / colour' : 'Choose a product first';
          this.variantSelect.appendChild(placeholder);

          if (!productId) {
            this.variantSelect.disabled = true;
            this.variantSelect.required = false;
            return;
          }

          const template = this.querySelector(`[data-variant-template="${productId}"]`);

          if (template) {
            this.variantSelect.appendChild(template.content.cloneNode(true));
          }

          const hasVariants = this.variantSelect.options.length > 1;
          this.variantSelect.disabled = !hasVariants;
          this.variantSelect.required = hasVariants;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
